import { Cognito } from '@shared/functions/cognito';
export const cognitoAuth = new Cognito({
  region: import.meta.env.VITE_AWS_COGNITO_REGION,
  userPoolId: import.meta.env.VITE_AWS_USER_POOLS_ID,
  userPoolWebClientId: import.meta.env.VITE_AWS_USER_POOLS_CLIENT_ID,
});
